/* eslint-disable @nx/enforce-module-boundaries */
import { Component } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { LicenseFormComponent } from '../license-form/license-form.component';
import { FormArray, FormGroup, NonNullableFormBuilder, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { BaseDialogStepperFormComponent } from 'admin-drivers/src/app/common/dialog/base-dialog-stepper-form';
import { MatIconModule } from '@angular/material/icon';
import { BehaviorSubject } from 'rxjs';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 't-llevo-licenses-form',
  standalone: true,
  imports: [
    AsyncPipe,
    MatExpansionModule,
    LicenseFormComponent,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule
  ],
  templateUrl: './licenses-form.component.html',
  styles: `
  .actions{
    display: flex;
    justify-content: end;
    width: 100%;
  }
  .mat-expansion-panel-header-description{
    justify-content: right;
  }
  `
})
export class LicensesFormComponent extends BaseDialogStepperFormComponent<FormArray<FormGroup>>{
  private stepsSubject = new BehaviorSubject(0);
  step$ = this.stepsSubject.asObservable()

  constructor(private _fb: NonNullableFormBuilder){
    super()
  }

  setStep(index: number) {
    this.stepsSubject.next(index);
  }

  nextStep() {
    this.stepsSubject.next(this.step + 1);
  }

  prevStep() {
    this.stepsSubject.next(this.step - 1);
  }

  private get step(){
    return this.stepsSubject.value
  }

  deleteLicense(index: number, event: Event){
    event.stopPropagation()
    this.frm.removeAt(index)

    if(this.step != 0){
      this.prevStep() 
    }
  }

  addLicense(event: Event){
    event.stopPropagation()
    const date = new Date().getFullYear()
    this.frm.push(
      this._fb.group({
        categories: this._fb.control<string[]>([], [Validators.required]),
        licenseNumber: ['', [Validators.required, Validators.pattern(/^[a-zA-Z]{1}[0-9]{6}$/)],],
        expeditionDate: ['', Validators.required],
        expiredYear: [date, [Validators.required, Validators.min(new Date().getFullYear()), Validators.max(2050), Validators.pattern(/^[0-9]{4}$/),]],
        image: this._fb.control<File | null>(null, [Validators.required]),
      })
    )
    this.setStep(this.frm.length - 1)
  }
}
